export default __webpack_public_path__ + "static/media/manage_members_icon.a86176f3.svg";